import React, { useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import SignatureCanvas, { ReactSignatureCanvasProps } from 'react-signature-canvas';
import { IRootState } from 'src/redux/rootReducer';
import './styles.scss';
import Element from '../common/Element';
import { isEmpty } from 'src/validations';
import { FiTrash } from 'react-icons/fi';
import { getRandomId } from 'src/utils';
import { View } from '../common';
const Signature: React.FC<Props> = ({
  label,
  onChange,
  errorMessage,
  containerClassName,
  classNames,
  name,
  onBlur,
  onClear,
  ...props
}) => {
  const id = useRef<SignatureCanvas>();
  const handleClear = () => {
    id.current.clear();
    onClear && onClear(name, null);
  };
  const handleSign = () => {
    const data = id.current.getCanvas().toDataURL('image/png');
    onChange(name, id.current.getTrimmedCanvas().toDataURL('image/png'));
    id.current.fromDataURL(data);
  };

  // For more information:

  const hasError = !isEmpty(errorMessage);
  return (
    <Element
      key={`signature-${getRandomId()}`}
      errorMessage={errorMessage}
      label={label}
      className={cn('cmp-signature', containerClassName)}>
      <View className={cn('cmp-signature__container', { hasError })} onBlur={() => onBlur && onBlur(name, true)}>
        <SignatureCanvas
          penColor="black"
          canvasProps={{ className: 'cmp-signature__table' }}
          minDistance={1}
          ref={id}
          onEnd={handleSign}
        />
        <View isRow justify="center" className="cmp-signature__footer">
          SIGN HERE
        </View>
        <FiTrash className="cmp-signature__footer__icon" onClick={handleClear} />
      </View>
    </Element>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  ReactSignatureCanvasProps & {
    errorMessage?: string;
    containerClassName?: string;
    classNames?: string;
    placeholder?: string;
    name?: string;
    label?: string | React.ReactNode;
    onChange: (name: string, value: any) => void;
    onBlur?: (name: string, value: boolean) => void;
    onClear?: (name: string, value: any) => void;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);
